import { SvgIconComponent } from '@mui/icons-material'
import { alpha, Box } from '@mui/material'

type SectionIconProps = {
  icon: SvgIconComponent
  size?: number
}
const SectionIcon = (props: SectionIconProps) => {
  const { icon: Icon, size = 36 } = props
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary.main',
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
      }}
    >
      <Icon fontSize="small" />
    </Box>
  )
}
export default SectionIcon
